<template>
    
    
    <div class="join-our-main">
    <div class="new-app-progress-area">
        <div class="container">
            <div class="row align-items-center mobile-reverse">
                <div class="col-lg-6 col-md-12">
                    <div class="new-app-progress-content">
                        <div class="big-text"></div>
                        <span class="sub-title text-uppercase  ">Our Team</span>
                        <h2>Join Our Team at Meander Software</h2>
                    <p><strong>Your Potential with a Leading Mobile App Development Company</strong> </p>
                        <p>At Meander Software, we specialize in cutting-edge mobile application clone development that empowers businesses worldwide. We’re on the lookout for talented, driven professionals to join our dynamic team and help us innovate, create, and deliver exceptional digital solutions.    
                        <router-link to="/contact" class="nav-link"><button class="default-btn">Get Started</button></router-link> </p>
                       <div class="new-app-pro-shape">
            <img src="../../assets/images/more-home/progress/shape-1.png" alt="image">
        </div>
                    </div>

                </div>

                <div class="col-lg-6 col-md-12">
                    <div class="new-app-progress-image text-center">
                        <img src="../../assets/images/more-home/progress/Why-Meander.png" alt="app-img">
                     
                    </div>
                </div>
            </div>
        </div>
        
    </div>
    </div>

<div class="work-why-meander">
   <div class="our-team-meander" style="background: #000;">
        <div class="container">
            <div class="row align-items-center">
               <div class="col-lg-6 col-md-12">
                    <div class="new-app-progress-image text-center">
                        <img src="../../assets/images/Join-Our-Team.png" alt="our team">
                    
                    </div>
                </div>
                <div class="col-lg-6 col-md-12">
                    <div class="new-app-progress-content">
                        <div class="big-text"></div>
                        <span class="sub-title text-uppercase  ">Work With</span>
                        <h2 class="text-white">Why Work With Us?</h2>
               
                        <p class="text-white">At Meander Software, we believe that great talent deserves a great environment. We offer exciting opportunities to work on innovative mobile app clone projects that push the boundaries of technology. Our flexible remote work policies and supportive team culture empower you to maintain a healthy work-life balance while growing your career. With access to continuous learning, skill development, and clear paths for advancement, you’ll be part of a forward-thinking company that values creativity, collaboration, and your professional success. Join us to make an impact in the fast-evolving world of mobile app development and bring your ideas to life.    
                        <router-link to="/contact" class="nav-link"><button class="default-btn">Get Started</button></router-link> </p>
                       
                    </div>

                </div>

               
            </div>
        </div>
     
    </div>
    </div>

<div class="looking-for-main">
     <div class="our-team-meander">
             
        <div class="container">
            <div class="row align-items-center position-relative">
                      <img src="../../assets/images/shape-three.png" alt="shape image" class="shape-image-looking">

                <div class="col-lg-6 col-md-12 shape-botton2">
                    <div class="new-app-progress-content">
                        <div class="big-text"></div>
                        <span class="sub-title text-uppercase  ">Looking For</span>
                        <h2>What We’re Looking For</h2>
                   
               <p class="mob-left"><strong>At Meander Software, we seek candidates who are:</strong></p>
                    <ul>
               <li>Passionate about mobile app development and digital solutions innovation</li>
                       <li>Skilled in relevant technologies and industry best practices</li>
                       <li>Team players with strong communication skills</li>
                       <li>Adaptable and eager to learn in a fast-paced environment</li>
                       </ul>
                    </div>
          <img src="../../assets/images/Technical-animation02.png" alt="shape image" class="shape-image-looking2">
            <div class="circle-animation-shape"></div>

                </div>
                 <div class="col-lg-6 col-md-12">
                    <div class="new-app-progress-image text-center">
                        <img src="../../assets/images/meander-img.jpg" alt="our team">
                    </div>
                </div>

               
            </div>
        </div>
     
    </div>
    </div>


 
    

</template>


<style>
/* <!-- meander our team section css --> */
.join-our-main {
    padding-top: 110px;
    padding-bottom: 20px;
}
.our-team-meander {
    padding: 50px 0;
}
.new-app-pro-shape img {
    position: absolute;
    top: -30px;
    width: 50px;
    left: -15px;
    z-index: -1;
    animation: movebounce 2s linear infinite;
}
.new-app-progress-area {
   position: unset;
}











/* 
Looking For */
.our-team-meander ul {
    padding-left: 18px;
}
.our-team-meander ul li {
    padding-left: 0px;
    text-align: left;
    width: 100%;
}
img.shape-image-looking {
    position: absolute;
    left: 20px;
    animation: movebounce 2s linear infinite;
    width: 80px;
    top: 0;
}
img.shape-image-looking2 {
    position: absolute;
    bottom: -40px;
    right: 40px;
    animation: movebounce 2s linear infinite;
}
.shape-botton2 {
    position: relative;
}






@media screen and (max-width: 767px) {
    .mobile-reverse {
        flex-direction: column-reverse;
        text-align: center;
    }
    .mobile-reverse .new-app-progress-image {
    margin-top: 0px;
}  
.mobile-reverse h2 {
   text-align: center;
}
.mobile-reverse p {
    text-align: center;
}
.our-team-meander p {
    text-align: center;
}
.our-team-meander .new-app-progress-content {
   padding-right: 0px;
}




/* 
Looking For */
.our-team-meander {
    padding: 30px 0 20px;
    text-align: center;
}
img.shape-image-looking2 {
    bottom: 0px;
    right: 20px;
    width: 50px;
}
img.shape-image-looking {
    left: 3px;
    width: 70px;
    top: 0px;
}
p.mob-left {
    text-align: left;
}
.new-app-pro-shape img {
    top: -35px;
    width: 45px;
    left: 0px;
}

.join-our-main {
    padding-top: 70px;
    padding-bottom: 10px;
}
}
</style>


<script>
export default {
    name: 'ChallengesAndTrack',
    methods: {
      openCalendly() {
     // eslint-disable-next-line no-undef
      Calendly.initPopupWidget({url:'https://calendly.com/connect-to-meander/30min'});
return false;
    }
  }
}
</script>